import { useQuery } from "@tanstack/react-query";
import { db } from "./supabase";

export interface PersonKurz {
  id: string;
  vorname: string;
  name: string;
  aufgabe: string;
  foto_pfad: string | null;
  aktiv: boolean;
  vorstand: boolean;
}

/** Alle Personen mit Zugang (Namen, Foto, Vorstand ja oder nein). Adressen sieht nur die Ansicht Zugänge. */
export function usePersonen() {
  return useQuery({
    queryKey: ["personen"],
    staleTime: 60_000,
    queryFn: async (): Promise<PersonKurz[]> => {
      const [p, m] = await Promise.all([
        db().from("app_personen").select("id, vorname, name, aufgabe, foto_pfad, aktiv").order("vorname"),
        db().from("app_mitgliedschaften").select("person, gruppe").eq("gruppe", "vorstand"),
      ]);
      if (p.error) throw p.error;
      if (m.error) throw m.error;
      const vorstand = new Set(m.data.map((x) => x.person));
      return p.data.map((x) => ({ ...x, vorstand: vorstand.has(x.id) }));
    },
  });
}

export function personNach(liste: readonly PersonKurz[] | undefined, id: string | null | undefined): PersonKurz | undefined {
  if (!id) return undefined;
  return liste?.find((p) => p.id === id);
}
